var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['description-list', _vm.size, _vm.layout === 'vertical' ? 'vertical' : 'horizontal']},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('a-row',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }